import { GiftsApiClient } from '@fourthwall/services/dist/GiftsApiClient'
import { createQueryHook } from '@fourthwall/utils/dist/queries'

export const useGiftQuery = createQueryHook(GiftsApiClient.getGift, {
  queryKey: ['gift'],
})
